export type StudioIndustry = 'fmcg' | 'technology' | 'fashion' | 'culture';

export interface StudioIndustryOption {
  id: StudioIndustry;
  label: string;
  description: string;
}

export const STUDIO_INDUSTRIES: StudioIndustryOption[] = [
  {
    id: 'fmcg',
    label: '快消',
    description: '食品饮料、美妆个护与日用消费品牌的上新、传播和电商内容。',
  },
  {
    id: 'technology',
    label: '科技',
    description: '数码硬件、软件服务与前沿技术的产品表达和品牌叙事。',
  },
  {
    id: 'fashion',
    label: '时尚',
    description: '服装、珠宝、美妆与生活方式品牌的视觉形象和动态内容。',
  },
  {
    id: 'culture',
    label: '文化',
    description: '文旅、艺术、非遗与公共文化项目的当代表达和内容传播。',
  },
];

export type StudioCaseCategoryId = 'all' | 'ad-tvc' | 'brand-film' | 'ecommerce' | 'short-film';

interface StudioCaseCategory {
  id: StudioCaseCategoryId;
  label: string;
  categoryIds: string[];
  tagNames: string[];
}

export const STUDIO_CASE_CATEGORIES: StudioCaseCategory[] = [
  {
    id: 'all',
    label: '全部',
    categoryIds: [],
    tagNames: [],
  },
  {
    id: 'ad-tvc',
    label: '广告/TVC',
    categoryIds: ['cat_ad_tvc'],
    tagNames: ['广告/TVC'],
  },
  {
    id: 'brand-film',
    label: '宣传片/品牌片',
    categoryIds: ['cat_brand_film'],
    tagNames: ['宣传片/品牌片', '宣传片/预告片'],
  },
  {
    id: 'ecommerce',
    label: '电商图/视频',
    categoryIds: ['cat_ecom_video', 'cat_product_render', 'cat_product_lifestyle'],
    tagNames: [
      '电商图/视频',
      '电商视频',
      '电商产品展示视频',
      '电商产品展示',
      '产品白底图',
      '产品渲染图',
      '产品外景图',
    ],
  },
  {
    id: 'short-film',
    label: '剧情短片/短剧',
    categoryIds: ['cat_short_film'],
    tagNames: ['剧情短片/短剧'],
  },
];

interface StudioCategorizedWork {
  tags?: string[];
  categories?: string[];
  industry?: StudioIndustry;
}

const normalizeTag = (value: string) => value.trim().toLowerCase().replace(/\s+/g, '');

export const matchesStudioCaseCategory = (
  work: StudioCategorizedWork,
  categoryId: StudioCaseCategoryId
): boolean => {
  if (categoryId === 'all') {
    return true;
  }

  const category = STUDIO_CASE_CATEGORIES.find((item) => item.id === categoryId);
  if (!category) {
    return false;
  }

  const categoryIds = new Set(work.categories || []);
  if (category.categoryIds.some((id) => categoryIds.has(id))) {
    return true;
  }

  const normalizedTags = new Set((work.tags || []).map(normalizeTag));
  return category.tagNames.some((name) => normalizedTags.has(normalizeTag(name)));
};

export const isStudioIndustry = (value: unknown): value is StudioIndustry => (
  STUDIO_INDUSTRIES.some((industry) => industry.id === value)
);
